import React from 'react';
import loadable from '@loadable/component';
import { redirectTo } from 'helpers/path';

const FitnessTrendsCommunityContainer = loadable(() =>
  import('features/FitnessTrends/Community/FitnessTrendsCommunityContainer')
);
const FitnessTrendsMemberContainer = loadable(() =>
  import('features/FitnessTrends/Member/FitnessTrendsMemberContainer')
);

export const FitnessTrendsRoute = () => ({
  path: '/fitness-trends',

  indexRoute: {
    onEnter: redirectTo('/fitness-trends/community/2018'),
  },

  childRoutes: [
    {
      path: 'community/:year',
      component: props => <FitnessTrendsCommunityContainer {...props} />,
    },
    {
      path: 'members/:memberHash/:year',
      component: props => <FitnessTrendsMemberContainer {...props} />,
    },
  ],
});
